module.exports = __webpack_public_path__ + "img/10-6.50ba03b3.png";